import React, { useState } from 'react';
import logo from '../../../../assets/img/logo.svg';
import { Notification } from '../../../components';
import { Icon } from '../../../elements';

const TransferApplicationHeader = () => {
  const [notifications, setNotifications] = useState([]);
  const [showNotifications, setShowNotifations] = useState(false);

  return (
    <header className="navigation">
      <div className="navigation-adjustment">
        <img src={logo} className="navigation-logo" alt="logo" />
        <div className="navigation-title-system">
          <span><strong>Processo de transferência</strong></span>
        </div>
        <div className="navigation-notification">
          {notifications.length > 0 && (<span className="notification-notify" />)}
          <button type="button" className="btn-none navigation-notification-button" onClick={() => setShowNotifations(true)}>
            <div className="navigation-notification-style">
              <i className="navigation-notification-icon"><Icon name="bell" white /></i>
            </div>
          </button>
        </div>
        <div className="navigation-space" />
        <Notification showNotification={showNotifications} notifications={notifications} onClickTimes={() => setShowNotifations(false)} />
      </div>
    </header>
  );
}

export default TransferApplicationHeader;
